export default __webpack_public_path__ + "aec8f65e66955cc9fa729fd08952796d.svg";